import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

const empty = { name:"", phone:"", address:"", city:"", state:"", pincode:"" };
export default function AdminPickup() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(empty);
  const load = () => api.get("/pickup-locations").then(r => setList(r.data));
  useEffect(() => { load(); }, []);
  const save = async (e) => { e.preventDefault(); await api.post("/pickup-locations", form); setForm(empty); load(); toast.success("Saved"); };
  const del = async (id) => { await api.delete(`/pickup-locations/${id}`); load(); };
  return (
    <div className="grid lg:grid-cols-[1fr_400px] gap-6 max-w-5xl">
      <div>
        <h1 className="font-display text-3xl font-bold mb-6">Pickup Locations</h1>
        <div className="space-y-3">
          {list.map(p => (
            <div key={p.pickup_id} className="bg-white border border-slate-100 rounded-2xl p-4 flex items-start justify-between">
              <div><div className="font-semibold">{p.name} · {p.phone}</div><div className="text-sm text-slate-600">{p.address}, {p.city}, {p.state} - {p.pincode}</div></div>
              <button data-testid={`del-pickup-${p.pickup_id}`} onClick={()=>del(p.pickup_id)} className="p-2 hover:bg-slate-100 rounded text-red-600"><Trash2 size={14}/></button>
            </div>
          ))}
          {list.length===0 && <div className="bg-slate-50 rounded-2xl p-10 text-center text-slate-500 text-sm">No pickup locations yet.</div>}
        </div>
      </div>
      <form onSubmit={save} className="bg-white border border-slate-100 rounded-2xl p-5 h-fit">
        <div className="flex items-center gap-2 mb-4"><Plus size={16}/><h3 className="font-display font-bold">Add Pickup Location</h3></div>
        {["name","phone","address","city","state","pincode"].map(k => (
          <input key={k} value={form[k]} onChange={e=>setForm({...form,[k]:e.target.value})} placeholder={k} required className="w-full bg-slate-50 border border-slate-200 rounded-xl px-3 py-2.5 text-sm mb-3" data-testid={`pickup-${k}`}/>
        ))}
        <button data-testid="pickup-save" className="btn-primary-sf w-full py-2.5 rounded-full text-sm font-semibold">Save Location</button>
      </form>
    </div>
  );
}
